import React from 'react';
import classNames from 'classnames';

import AlignLeftAndRight from 'components/AlignLeftAndRight';
import './styles.scss';

interface Props {
    isHeader?: boolean;
    left: React.ReactElement;
    right?: React.ReactElement;
}

export class VirtualizedTableColumnListItemWrapperComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { isHeader, left, right } = this.props;

        return (
            <div
                className={classNames('VirtualizedTableColumnListItemWrapper', {
                    header: isHeader
                })}
            >
                <AlignLeftAndRight
                    left={left}
                    right={
                        <div className="VirtualizedTableColumnListItemWrapper-button-column">
                            {right}
                        </div>
                    }
                    noMargin
                    expandLeft
                />
            </div>
        );
    }
}

export default VirtualizedTableColumnListItemWrapperComponent;
